"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapPageElement;
var _react = _interopRequireDefault(require("react"));
var _components = require("@bluefin/components");
function wrapPageElement(_ref, pluginOptions) {
  var element = _ref.element;
  var accountId = pluginOptions.accountId,
    _pluginOptions$strate = pluginOptions.strategy,
    strategy = _pluginOptions$strate === void 0 ? _components.Script.DEFAULT_SCRIPT_LOAD_STRATEGY : _pluginOptions$strate,
    _pluginOptions$target = pluginOptions.targetSelector,
    targetSelector = _pluginOptions$target === void 0 ? _components.Script.DEFAULT_TARGET_SELECTOR : _pluginOptions$target;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, element, /*#__PURE__*/_react["default"].createElement(_components.Script, {
    key: accountId,
    strategy: strategy,
    targetSelector: targetSelector,
    dangerouslySetInnerHTML: {
      __html: "(function(d){ var s = d.createElement(\"script\");\n        s.setAttribute(\"data-position\", \"5\");\n        s.setAttribute(\"data-account\", \"".concat(accountId, "\");\n        s.setAttribute(\"src\", \"https://cdn.userway.org/widget.js\");\n        (d.body || d.head).appendChild(s);})(document)")
    }
  }));
}